import { IMatchStartupFormations, MatchStartupFormations } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpMatchLineupsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";
import { graphql } from "appsync";
import { useSubscription } from "../../hooks/useSubscription";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpMatchLineupsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql("subscription LmpLineupSubscription($matchId: ID!) {\n  lineups: onUpdateLmpLineupByMatchId(matchId: $matchId) {\n    matchId\n    status\n    referees {\n      fullname\n      id\n      name\n      surname\n    }\n    home {\n      formation\n      id\n      logoUrl\n      name\n      topPlayerId\n      playerList {\n        manager {\n          fullname\n          id\n          name\n          role\n          surname\n        }\n        startingLineup {\n          formationPlace\n          fullname\n          id\n          jerseyNum\n          name\n          role\n          surname\n        }\n        substitutes {\n          formationPlace\n          fullname\n          id\n          jerseyNum\n          name\n          role\n          surname\n        }\n      }\n      goals {\n        id\n        minutes\n        type\n      }\n      scorersCards {\n        id\n        minutes\n        type\n      }\n      substitution {\n        minutes\n        playerIdIn\n        playerIdOut\n      }\n    }\n    away {\n      formation\n      id\n      logoUrl\n      name\n      topPlayerId\n      playerList {\n        manager {\n          fullname\n          id\n          name\n          role\n          surname\n        }\n        startingLineup {\n          formationPlace\n          fullname\n          id\n          jerseyNum\n          name\n          role\n          surname\n        }\n        substitutes {\n          formationPlace\n          fullname\n          id\n          jerseyNum\n          name\n          role\n          surname\n        }\n      }\n      goals {\n        id\n        minutes\n        type\n      }\n      scorersCards {\n        id\n        minutes\n        type\n      }\n      substitution {\n        minutes\n        playerIdIn\n        playerIdOut\n      }\n    }\n  }\n}");

export const getServerProps = ({
  props,
}: WidgetContext<LmpMatchLineupsQuery>): IMatchStartupFormations => {
  return transformer(props);
}

const LmpLineupsWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<IMatchStartupFormations>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    IMatchStartupFormations,
    LmpMatchLineupsQuery,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables: {
      matchId: variables.matchId
    },
    transform: transformer,
    mergeData: false,
  }) as IMatchStartupFormations;

  return (
    <div onClick={intCmpEventHandler}>
        <MatchStartupFormations {...updatedProps} />
    </div>
  );
}

export default LmpLineupsWidget;

